<!-- 订单状态 -->
<template>
    <div class="container" style="width: 5.36rem;" ref="wintacLoading"
         :style="{ '--color': themeColor, '--lightColor': lightThemeColor }">
        <div v-if="datas.seconds && datas.seconds > 0" style="display: flex;
         margin-bottom: 0.1rem">
            <Countdown @countdown-ended="datas.seconds = null" :second="datas.seconds"></Countdown>
        </div>
            <div style="display: flex;">
                <div style="flex: 1">
                    <div class="titleBox" style=" width: 5.36rem;">
                        <div class="btns" @click="scrollToLeft">
                            <i class="el-icon-arrow-left"></i>
                        </div>
                        <div class="center" ref="center">
                            <div class="box" style="display: flex; align-items: center"
                                 v-for="(item, index) in datas.statusResultList"
                                 :key="index">
                                <div class="btns1">
                                    <div style="display: flex; align-items: center; position: relative">
                                        <div class="yuan" :class="item.highlight ? 'highlight' : ''">
                                            {{ item.serialNumber }}
                                        </div>
                                        <div v-if="index !== datas.statusResultList.length - 1" class="line"></div>
                                    </div>
                                    <p class="p1" :class="item.highlight ? 'textHighlight' : ''">{{
                                            item.statusText
                                        }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="btns" @click="scrollToRight">
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                    <div class="footerBox">
                        <div class="footerLine" v-for="(item, index) in datas.opLogResults" :key="index">
                            <div  style="display:flex;align-items:center;transform: scale(0.9); transform-origin: 0 0;white-space: nowrap;">
                                <svg-icon class="svg" style="margin-right: 0.08rem;" iconClass="naozhong"></svg-icon>
                                <p :class="{'isBlod':index === 0}" class="p1" v-html="item.remark"></p>
                            </div>
                        </div>
                        <div class="operatingButton">
                            <div v-for="(n) in datas.opButtonResultList" :key="n.buttonName">
                                <DynamicButton v-if="dataType == 0 || n.functionName === 'viewInquiry'"
                                               @click="update(n.functionName)"
                                               style="margin-right: 0.1rem;" :style="{
                  color: n.buttonColor ? n.buttonColor : '#fff',
                  backgroundColor: n.buttonBackgroundColor ? n.buttonBackgroundColor : '#DE562C',
                  borderColor: n.buttonBackgroundColor ? n.buttonBackgroundColor : '#DE562C',
                }" size="mini" :buttonText="n.buttonName" :permFlag="true" perm="ce">
                                </DynamicButton>
                            </div>
                            <DynamicButton v-if="isShowModifyPriceBtn()" @click="update('adjustOrderContentAndAmount')"
                                           style="margin-right: 0.1rem;" :style="{
                color: '#fff',
                backgroundColor: '#DE562C',
                borderColor: '#DE562C',
              }" size="mini" buttonText="修改价格" :permFlag="true" perm="ce">
                            </DynamicButton>
                            <el-button v-if="allDatas.state === 3 || allDatas.state === 5"
                                       @click="$emit('handlerSeeConfirm', allDatas)" size="mini" type="primary">查看已确认行程
                            </el-button>
                            <el-button size="mini" type="primary" v-if="dataType === 1" class="contactBtn" @click="openChat">联系客户</el-button>

                            <!-- 可能需要修改 -->
                            <!-- <el-button v-if="allDatas.showCancel === 1" @click="update('modifyOrder')" type="primary"
                                       size="mini"
                                       class="btns3">修改订单
                            </el-button> -->
                        </div>
                    </div>
                </div>
            <!-- <div v-if="allDatas.showCancel === 1"
              style="flex: 1;border-left: 1px dotted #D6E2FB;display: flex;flex-direction: column;justify-content: center;margin-left: 0.05rem;height: 1.8rem;">
              <div>
                <el-button @click="update(isq() ?  'cancelOrder' : 'payCancelOrder')" style="margin-bottom: 0.1rem;" type="primary" size="mini"
                  class="btns3">取消订单</el-button>
              </div>
              <div v-if="allDatas.showCancel === 1">
                <el-button @click="update('modifyOrder')" type="primary" size="mini" class="btns3">修改订单</el-button>
              </div>
            </div> -->
        </div>
        <remarkPopup ref="remarkPopup"></remarkPopup>
        <createPreOrder ref="createPreOrder"></createPreOrder>
        <modifyTable :tableData="[JSON.parse(JSON.stringify(allDatas))]" ref="modifyTable"></modifyTable>
        <orderChangePopup :childrenIds="[orderChildrenId]" :allDatas="allDatas"
                          ref="cancelOrderPopup"></orderChangePopup>
        <orderCancellationPopup ref="orderCancellationPopup"></orderCancellationPopup>
        <inquiryDetailsPopup :allDatas="allDatas" ref="inquiryDetailsPopup"></inquiryDetailsPopup>
        <static-pay-table ref="staticPayTable"></static-pay-table>
        <confirmFeesAndCancelOrders @updateList="$emit('updateList')" ref="confirmFeesAndCancelOrders"></confirmFeesAndCancelOrders>
        <!-- 聊天弹框组件 -->
        <ChatModal
            :show="showChatModal"
            :user-info="{
                userId: allDatas.createId
            }"
            @close="closeChatModal"
        />
    </div>
</template>
<script>
import {mapState} from "vuex";
import Pay from '@/components/ThirdPay/Pay'
import {OrderMinxin} from '../sonOrderMinxin'
import remarkPopup from './remarkPopup.vue'
import createPreOrder from '../../../../plan/leftMoudle/dialog/createPreOrder.vue'
import modifyTable from './modifyTable.vue'
import {Loading} from "@/components/Loding/Loading";
import orderChangePopup from './orderChangePopup.vue';//订单变更弹框
import orderCancellationPopup from "./orderCancellationPopup.vue";//订单取消弹框
import confirmFeesAndCancelOrders from "./confirmFeesAndCancelOrders.vue";//待确认时取消费用弹框
import inquiryDetailsPopup from './inquiryDetailsPopup.vue';
import StaticPayTable from "@/views/mechanism/components/myDealChild/child/staticPayTable.vue";
import ChatModal from "@/views/message/ChatModal.vue";

//查看询单弹框
export default {
    components: {
        ChatModal,
        StaticPayTable,
        Pay,
        remarkPopup,
        createPreOrder,
        modifyTable,
        orderChangePopup,
        orderCancellationPopup,
        inquiryDetailsPopup,
        confirmFeesAndCancelOrders,

    },
    mixins: [OrderMinxin, Loading],
    props: {
        datas: {
            type: Object,
            default: {}
        },
        //总价
        // totalPrice: {

        // },
        //这条数据的全部数据
        allDatas: {
            type: Object,
            default: {}
        },
        dataType: {
            default: 0
        },
        //子订单号
        orderChildrenId: {
            type: String,
            default: ""
        },
        orderMainId: {
            type: String,
            default: () => {
                return ""
            }
        },
        isLock: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showChatModal:false,
            stateList: [
                {
                    state: "已支付",
                },
                {
                    state: "已支付",
                },
                {
                    state: "已支付",
                },
                {
                    state: "已支付",
                },
            ],
        };
    },
    computed: {
        ...mapState(["themeColor"]),
        ...mapState(["lightThemeColor"]),
        ...mapState(["nearThemeColor"]),
    },
    watch: {
        datas: {
            handler(n, m) {
                this.$nextTick(() => {
                    this.closeLoading()
                    if (this.datas.lock == 1) {
                        this.createLoading({
                            innerText: ' ',
                            isAnimation: false,
                            isMask: true,
                            background: 'rgba(255,255,255,0.6)',
                            icon: require('@/assets/png/suoding.png'),
                            content: '该订单内容正在重新处理中,请等待解锁支付...'
                        })
                    }
                    if (this.isLock) {
                        this.closeLoading()
                        this.$nextTick(() => {
                            this.createLoading({
                                innerText: ' ',
                                isAnimation: false,
                                isMask: true,
                                background: 'rgba(255,255,255,0.6)',
                                icon: require('@/assets/png/suoding.png'),
                                content: '该订单内容正在操作中...',
                                isButton: true,
                            })
                        })
                    }
                })
            },
            deep: true,
            immediate: true
        },
    },
    methods: {
        openChat() {
            this.showChatModal = true
        },
        closeChatModal() {
            this.showChatModal = false
        },
        //时间排序
        sortByCreateTime(array) {
            if (array.length > 1) {
                return array.sort((a, b) => {
                    const dateA = new Date(a.createTime);
                    const dateB = new Date(b.createTime);
                    return dateB - dateA;
                });
            } else {
                return array
            }
        },
        //处理按钮的显示与隐藏
        isShowModifyPriceBtn() {
            let flag = false
            let arr = this.datas.statusResultList.filter(n => n.highlight == 1)
            if (arr.length == 1) {
                if (arr[0].statusName === 'TO_BE_PAID' && this.dataType == 1) {
                    return true
                }
            } else {
                return flag
            }
        },
        //取消订单的两种情况
        isq() {
            let flag = false
            let arr = this.datas.statusResultList.filter(n => n.highlight == 1)
            if (arr.length == 1) {
                if (arr[0].statusText === '待支付') {
                    return true
                }
            } else {
                return flag
            }
        },
        scrollToLeft() {
            const container = this.$refs.center;
            container.scrollTo({
                left: 0,
                behavior: 'smooth',
            });
        },
        scrollToRight() {
            const container = this.$refs.center;
            container.scrollTo({
                left: container.scrollWidth - container.clientWidth,
                behavior: 'smooth',
            });
        },
    },
    created() {

    },
    mounted() {
        this.scrollToRight()
        this.datas.opLogResults = this.sortByCreateTime(this.datas.opLogResults)
    },
};
</script>
<style lang="scss" scoped>
.highlight {
    color: #fff !important;
    background-color: #dd5827;
    border-color: #dd5827 !important;
}

.textHighlight {
    color: #dd5827 !important;
}

::-webkit-scrollbar {
    display: none;
}

.isBlod {
    font-weight: bold;
}
.container {
    width: 100%;
    position: relative;  
      
    .contactBtn {
        //position: absolute;
        //right: 0.1rem;
        //top: -0.1rem;
    }
    .titleBox {
        display: flex;
        align-items: center;
        margin-bottom: 0.12rem;
        // width: 5.5rem;

        .center {
            flex: 1;
            display: flex;
            align-items: center;
            margin: 0 0.25rem;
            white-space: nowrap;
            overflow-y: scroll;

            .line {
                position: absolute;
                width: 0.45rem;
                height: 1px;
                border-bottom: 2px solid #C0C4CB;
                right: -0.58rem;
            }

            .box {
                margin-right: 0.4rem;

                &:nth-last-child(1) {
                    margin-right: 0;
                }

                .btns1 {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    position: relative;
                    width: 0.6rem;
                    height: 0.55rem;

                    .p1 {
                        position: absolute;
                        bottom: 0;
                        // left: 50%;
                        // transform: translateX(-50%);
                        transform: scale(0.85);
                    }

                    .yuan {
                        width: 0.27rem;
                        height: 0.27rem;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 2px solid #C0C4CB;
                        color: #C0C4CB;
                        font-size: 0.15rem;
                        cursor: pointer;
                    }
                }
            }
        }

        .btns {
            width: 0.14rem;
            height: 0.6rem;
            line-height: 0.6rem;
            background-color: #E1F5F4;
            color: #53C2B5;
            text-align: center;
            cursor: pointer;

            &:hover {
                background-color: #dd5827;
                color: #fff !important;
                transition: all .5s ease;
            }
        }
    }

    .footerBox {
        text-align: left;
        padding: 0 0.14rem 0 0.4rem;

        .operatingButton {
            display: flex;
            align-items: center;
            margin-top: 0.1rem;
        }

        .footerLine {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-right: 0.14rem;

            .svg {
                width: 17px;
                height: 17px;
            }

            .p1 {
                left: 982px;
                color: rgba(16, 16, 16, 1);
                font-size: 0.12rem;
                font-family: SourceHanSansSC-regular;
            }

            .p2 {
                font-size: 0.12rem;
                color: var(--color);
                font-weight: bold;
            }
        }
    }
}
</style>
